import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
import { isFlagSet, setFlag } from 'z3k-parser/lib/flags';
export var BoilerCascade;
(function (BoilerCascade) {
    let Flags;
    (function (Flags) {
        Flags[Flags["MODULATING_CASCADE"] = 1] = "MODULATING_CASCADE";
        Flags[Flags["RESERVE"] = 2] = "RESERVE";
        Flags[Flags["CONSIDER_MODULATION"] = 4] = "CONSIDER_MODULATION";
    })(Flags = BoilerCascade.Flags || (BoilerCascade.Flags = {}));
    function isOff(boiler_cascade) {
        return boiler_cascade.rotation_period == 0;
    }
    BoilerCascade.isOff = isOff;
    function isModulatingCascadeEnabled(boiler_cascade) {
        return isFlagSet(boiler_cascade, Flags.MODULATING_CASCADE);
    }
    BoilerCascade.isModulatingCascadeEnabled = isModulatingCascadeEnabled;
    function setModulatingCascade(boiler_cascade, enabled) {
        return setFlag(boiler_cascade, Flags.MODULATING_CASCADE, enabled);
    }
    BoilerCascade.setModulatingCascade = setModulatingCascade;
    function isConsiderModulationEnabled(boiler_cascade) {
        return isFlagSet(boiler_cascade, Flags.CONSIDER_MODULATION);
    }
    BoilerCascade.isConsiderModulationEnabled = isConsiderModulationEnabled;
    function setConsiderModulation(boiler_cascade, enabled) {
        return setFlag(boiler_cascade, Flags.CONSIDER_MODULATION, enabled);
    }
    BoilerCascade.setConsiderModulation = setConsiderModulation;
    BoilerCascade.get = createAccessors(arrayGetSet('boiler_cascades'), {
        name: 'Каскад котлов',
        rotation_period: 1,
        setting_register: 0,
        slave_boiler_start_delay: 10,
        slave_boiler_finish_delay: 10,
        lead_boiler_switch_delay: 10,
        boiler_list: [],
        water_sensor: null,
        hysteresis: 5,
    });
})(BoilerCascade || (BoilerCascade = {}));
